export const urlBack = 'https://laverdadminera.mx/back/' 
// export const urlBack = 'http://localhost/laverdadminera-back/'
